/**
 * 百度统计_事件统计
 * @param {string} category 必须，表示事件发生在谁身上
 * @param {string} action 必须，表示访客跟元素交互的行为动作
 * @param {string} string 可选，用于更详细的描述事件
 * @param {string} int 可选，用于填写打分型事件的分值，加载时间型事件的时长，如果填写为其他形式，系统将按0处理。若填写为浮点小数，系统会自动取整，去掉小数点。
 */
export default function trackEvent(category, action, opt_label, opt_value) {
  this.$ba.trackEvent(category, action, opt_label, opt_value)
}
